import RCTooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import React from 'react';
import { useTheme } from 'styled-components';
import { ToolTipStyles } from './tooltip.styled';
import { TooltipProps } from './tooltip.types';

const Tooltip = (props: TooltipProps, ref?: React.Ref<unknown>) => {
  const {
    mouseEnterDelay = 0.1,
    mouseLeaveDelay = 0.1,
    className,
    children,
    variant = 'large',
    Icon,
    content,
    defaultVisible = false,
    style,
    ...rest
  } = props;
  const theme = useTheme();
  const overlayColor = variant === 'large' ? theme.color.surface.inverse : theme.color.surface.info;

  const [isOpen, setIsOpen] = React.useState(defaultVisible ?? false);

  return (
    <>
      <ToolTipStyles />
      <RCTooltip
        {...rest}
        ref={ref}
        showArrow
        mouseEnterDelay={mouseEnterDelay}
        mouseLeaveDelay={mouseLeaveDelay}
        defaultVisible={defaultVisible}
        zIndex={99999}
        overlayStyle={{
          zIndex: 99999,
          opacity: 1,
        }}
        overlay={
          <span
            className={className}
            style={
              variant === 'large'
                ? {
                    color: theme.color.tint.onSolid,
                    ...theme.typography.captionLarge,
                    ...style,
                  }
                : {
                    color: theme.color.tint.primary,
                    ...theme.typography.captionSmall,
                    ...style,
                  }
            }
          >
            {content}
          </span>
        }
        overlayInnerStyle={{
          maxWidth: 250,
          borderColor: overlayColor,
          background: overlayColor,
          opacity: 1,
          padding: variant === 'large' ? '4px 8px' : '4px',
        }}
        onVisibleChange={(v) => {
          props.onVisibleChange?.(v);
          setIsOpen(v);
        }}
        overlayClassName={`ui-tooltip-${variant}`}
      >
        {Icon ? (
          <Icon
            width={16}
            height={16}
            color={isOpen ? theme.color.state.active : theme.color.tint.tertiary}
            style={{ marginLeft: 8, cursor: 'pointer' }}
          />
        ) : (
          React.cloneElement(React.Children.only(children), { isOpen })
        )}
      </RCTooltip>
    </>
  );
};

export default React.forwardRef(Tooltip);
